/**
 * Refresh all carousels inside container
 * @param {HTMLElement} container Node to find carousels inside
 * @returns {HTMLElement}
 */
import Media from "../components/Media.js";
import RelatedCarousel from "../components/Related.js";
function refreshCarousels(container) {
    const carousels = container.querySelectorAll("[data-carousel]");

    carousels.forEach((element) => {
        const id = element.getAttribute("data-carousel");

        // If carousel already has slick defined refresh it else set up new slick instance
        if (element.carousel) {
            element.carousel.slick("refresh");
        } else {
            if (id.includes("media")) new Media(element);
            if (id.includes("related")) new RelatedCarousel(element);
        }
    });
}

/**
 * Refresh all dialogs inside container
 * @param {HTMLElement} container Node to find dialog buttons inside
 * @returns {HTMLElement}
 */
import Dialog from "../Dialog.js";
function refreshDialogs(container) {
    const dialogElements = container.querySelectorAll("[data-dialog]");
    dialogElements.forEach((button) => {
        new Dialog(button);
    });
}

/**
 * Refresh all accordions inside container
 * @param {HTMLElement} container Node to find dialog buttons inside
 * @returns {HTMLElement}
 */
import Accordion from "../components/Accordion.js";
function refreshAccordions(container) {
    const accordionElements = container.querySelectorAll(
        ".accordion-content-outer",
    );
    accordionElements.forEach((element) => {
        new Accordion(element);
    });
}

export default { refreshCarousels, refreshDialogs, refreshAccordions };
